import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerStmtExpDetailService } from '../owner-stmt-exp-detail.service';
import { OwnerStmtExpDetail } from '../owner-stmt-exp-detail';
import { OwnerStmtExpDetailComponent } from '../owner-stmt-exp-detail/owner-stmt-exp-detail.component';

@Component({
    selector: 'app-owner-stmt-exp-detail-list',
    templateUrl: './owner-stmt-exp-detail-list.component.html',
    styleUrls: ['./owner-stmt-exp-detail-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerStmtExpDetailListComponent implements OnInit {
	constructor(
		private ownerStmtExpDetailService: OwnerStmtExpDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ownerStmtExpDetailService.statuses
	}

	// data
	@Input() ownerStmtExpId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	ownerStmtExpDetails: any;
	ownerStmtExpDetail: OwnerStmtExpDetail;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ownerStmtExpDetailId', header: 'Id', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		// { field: 'srcStatus', header: 'Status', width: 'auto' },
		{ field: 'quantity ', header: 'Quantity', width: 'auto' },
		{ field: 'amount', header: 'Amount', width: 'auto' },
		{ field: 'taxAmount', header: 'Tax Amount', width: 'auto' },
		{ field: 'taxPct', header: 'Tax Pct', width: 'auto' },

	];

	ngOnInit(): void {
	console.log('ownerStmtExpId : ' + this.ownerStmtExpId);
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerStmtExpDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerStmtExpDetail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.ownerStmtExpId)
			{
				// show only guestRefunds that are assigned to this guestRefundId
				let ownerStmtExpIdFilter = { 'ownerStmtExpId': { 'value': this.ownerStmtExpId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerStmtExpIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerStmtExpDetailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerStmtExpDetails = res.data.ownerStmtExpDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerStmtExpDetails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerStmtExpDetail: OwnerStmtExpDetail) {
		try {
			this.formLoading = true;
			this.ownerStmtExpDetailService.update(ownerStmtExpDetail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtExpDetails.map((ownerStmtExpDetail, i) => {
							if (ownerStmtExpDetail.ownerStmtExpDetailId === res.data.ownerStmtExpDetail.ownerStmtExpDetailId) {
								this.ownerStmtExpDetails[i] = res.data.ownerStmtExpDetail;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerStmtExpDetail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerStmtExpDetail));

			this.formLoading = true;
			this.ownerStmtExpDetailService.delete(ownerStmtExpDetail.ownerStmtExpDetailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtExpDetails.splice(this.ownerStmtExpDetails.indexOf(ownerStmtExpDetail), 1);
						this.recordTotal = this.ownerStmtExpDetails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerStmtExpDetail ' + ownerStmtExpDetail.ownerStmtExpDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerStmtExpDetail ' + ownerStmtExpDetail.ownerStmtExpDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerStmtExpDetail',
			ownerStmtExpId: this.ownerStmtExpId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtExpDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerStmtExpDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerStmtExpDetail: OwnerStmtExpDetail) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmtExpDetail: ownerStmtExpDetail,
			title: 'Edit OwnerStmtExpDetail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtExpDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerStmtExpDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerStmtExpDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerStmtExpDetailCB(ownerStmtExpDetail: OwnerStmtExpDetail) {
		console.log('Adding OwnerStmtExpDetail: ' + JSON.stringify(ownerStmtExpDetail));
		// if we don't have a ownerStmtExpDetails array yet...
		if (!this.ownerStmtExpDetails) {
			this.ownerStmtExpDetails = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerStmtExpDetails.unshift(ownerStmtExpDetail);

		// no idea what this is but it is required to update the array
		this.ownerStmtExpDetails = [...this.ownerStmtExpDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExpDetail ' + ownerStmtExpDetail.ownerStmtExpDetailId + ' Added', life: 3000 });
	}

	updateOwnerStmtExpDetailCB(ownerStmtExpDetail: OwnerStmtExpDetail) {
		console.log('Updating OwnerStmtExpDetail: ' + JSON.stringify(ownerStmtExpDetail));
		let itemIndex = this.ownerStmtExpDetails.findIndex((item: any) => item.ownerStmtExpDetailId === ownerStmtExpDetail.ownerStmtExpDetailId);
		this.ownerStmtExpDetails[itemIndex] = ownerStmtExpDetail;

		// no idea what this is but it is required to update the array
		this.ownerStmtExpDetails = [...this.ownerStmtExpDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExpDetail ' + ownerStmtExpDetail.ownerStmtExpDetailId + ' Updated', life: 3000 });
	}

	deleteOwnerStmtExpDetailCB(ownerStmtExpDetail: OwnerStmtExpDetail) {
		console.log('Removing OwnerStmtExpDetail: ' + ownerStmtExpDetail);
		this.ownerStmtExpDetails.splice(this.ownerStmtExpDetails.indexOf(ownerStmtExpDetail), 1);
		this.recordTotal = this.ownerStmtExpDetails.length;

		// no idea what this is but it is required to update the array
		this.ownerStmtExpDetails = [...this.ownerStmtExpDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmtExpDetail ' + ownerStmtExpDetail.ownerStmtExpDetailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerStmtExpDetails ? this.first === (this.ownerStmtExpDetails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerStmtExpDetails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerStmtExpDetail: any) {
		if (ownerStmtExpDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerStmtExpDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
